import { useTypedParams } from '@sorare/routing';

import { WatchlistsLayout } from '@sorare/marketplace/src/components/watchlists/WatchlistsLayout';

import { AppLayout } from 'components/navigation/AppLayout';

import type { LayoutParams } from './__generated__/routeParams';

export const WatchlistLayout = () => {
  const { id } = useTypedParams<LayoutParams>();

  return (
    <AppLayout>
      <WatchlistsLayout id={id} />
    </AppLayout>
  );
};

export default WatchlistLayout;
